import React from 'react';
import Cookies from 'js-cookie';
import { AiOutlineWarning } from 'react-icons/ai';

interface IErrorBoundaryProps {
  children: React.ReactNode;
}

interface IErrorBoundaryState {
  erro?: Error;
}

// Sem este componente, qualquer erro na renderização desmonta o app inteiro e o usuário vê só uma tela em branco
export default class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  state: IErrorBoundaryState = {};

  static getDerivedStateFromError(erro: Error): IErrorBoundaryState {
    return { erro };
  }

  componentDidCatch(erro: Error, info: React.ErrorInfo) {
    console.error('Erro não tratado na aplicação:', erro, info.componentStack);
  }

  // Remove a sessão (pode estar corrompida) e volta para o login da empresa atual
  irParaLogin() {
    Cookies.remove('usuarioCookie');

    const caminho = window.location.pathname.split('/')[1];
    window.location.href = caminho ? `/${caminho}/login` : '/';
  }

  render() {
    const { erro } = this.state;

    if (!erro) return this.props.children;

    return (
      <main className='flex min-h-screen items-center justify-center bg-zinc-50 px-4'>
        <div className='w-full max-w-md rounded-2xl border border-zinc-200 bg-white p-6 text-center shadow-card animate-fade-in motion-reduce:animate-none'>
          <span className='mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 text-amber-600'>
            <AiOutlineWarning className='h-6 w-6' aria-hidden='true' />
          </span>
          <h1 className='mt-4 text-xl font-semibold text-zinc-900'>Algo deu errado</h1>
          <p className='mt-1 text-sm text-zinc-500'>
            Não foi possível carregar esta página. Tente recarregar ou acessar novamente pelo login.
          </p>

          <div className='mt-6 space-y-2'>
            <button
              type='button'
              onClick={() => window.location.reload()}
              className='flex h-12 w-full items-center justify-center rounded-xl bg-zinc-900 px-5 font-semibold text-white transition-colors hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
            >
              Recarregar página
            </button>
            <button
              type='button'
              onClick={() => this.irParaLogin()}
              className='flex h-12 w-full items-center justify-center rounded-xl border border-zinc-200 bg-white px-5 font-semibold text-zinc-900 transition-colors hover:bg-zinc-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
            >
              Voltar ao login
            </button>
          </div>

          {/* Detalhe técnico para o cliente repassar ao suporte (print da tela) */}
          <details className='mt-6 text-left'>
            <summary className='cursor-pointer text-xs text-zinc-400'>Detalhes do erro</summary>
            <pre className='mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded-xl bg-zinc-50 p-3 text-xs text-zinc-600'>
              {erro.message}
              {'\n'}
              {window.location.href}
              {'\n'}
              {navigator.userAgent}
            </pre>
          </details>
        </div>
      </main>
    );
  }
}
